export default function (data) {
  var dataStyle = {
    normal: {
      label: {
        show: true,
        color: "#fff",
        fontSize: 10,
      },
      labelLine: {
        //smooth: 0.2,
        length: 6,
        length2: 6,
      },
    },
  };
  var labelShow = {
    show: true,
    color: "#fff",
    fontSize: 15,
    formatter: ["{d| {d}% }", "{b| {b} }"].join("\n"),
    rich: {
      d: {
        fontSize: 10,
        color: "#fff",
      },
      b: {
        fontSize: 10,
        color: "#fff",
      },
    },
  };
  return {
    backgroundColor: "rgba(0, 0, 0, 0)",
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b}: {c} ({d}%)",
    },
    legend: {
      show: false,
      orient: "vertical",
      x: "right",
      itemWidth: 14,
      itemHeight: 14,
      align: "left",
      data: [],
      textStyle: {
        color: "#fff",
      },
    },
    calculable: true,
    series: [
      {
        name: "",
        type: "pie",
        roseType: "area",
        radius: ["30%", "50%"],
        // radius: [55, 65],
        center: ["50%", "50%"],
        itemStyle: dataStyle,
        color: [
          "rgb(170, 238, 255)",
          "rgb(121, 218, 255)",
          "rgb(0, 179, 255)",
          "rgb(36, 131, 255)",
          "rgb(87, 205, 255)",
          "rgb(10, 115, 255)",
          "rgb(121, 218, 255)",
        ],
        label: {
          normal: labelShow,
        },
        data: data,
      },
    ],
  };
}
